import styled from 'styled-components'

const Common = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex: 0 0 auto;
  height: 3.5rem;
  line-height: 3.5rem;
  font-size: 1rem;
  text-align: center;
  background-color: #EFE5C1;
  place-items: center;
  pointer-events: all;
`
const Header = styled(Common)`
  width: 100%;
  /*height: 1rem;*/
  /*flex: 0;*/
`
const Footer = styled(Common)`
  /*height: 1rem;*/
`

export { Header, Footer };
